import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from '../modules/components/Section';
import Eyebrow from '../modules/components/Eyebrow';

const rows = [
  { title: '会社名', detail: ['飯田建築有限会社'] },
  { title: '住所', detail: ['〒358-0054 埼玉県入間市野田1481-2'] },
  { title: '代表者', detail: ['飯田 修一'] },
  { title: '資本金', detail: ['300万円'] },
  {
    title: '事業内容',
    detail: [
      '新築、増改築、戸建てリノベーション、マンションリノベーション、各種リフォーム（水まわり、キッチン、UB、窓まわり、外壁、エクステリア、電気、給排水）、倉庫・工場の建築及び修繕、プレハブ建築',
    ],
  },
  { title: 'TEL / FAX', detail: ['04-2932-1316 / 04-2932-4189'] },
  { title: '主要取引銀行', detail: ['飯能信用金庫、三井住友銀行'] },
  {
    title: '許可・登録',
    detail: ['建設業: 埼玉県知事許可（般一23）第2679号', '設計: 埼玉県知事許可（般一23）第2679号'],
  },
];

/** 会社概要。MUI Table をやめ罫線付きの定義リストに。 */
function Company() {
  return (
    <Section bg="kinari">
      <Box sx={{ textAlign: 'center', mb: { xs: 5, sm: 8 } }}>
        <Eyebrow>Profile</Eyebrow>
        <Typography variant="h2" component="h2">
          会社概要
        </Typography>
      </Box>

      {/* my:0 で dl 既定の上下マージンだけを消す。m:0 にすると mx:'auto' が潰れて中央寄せが効かない */}
      <Box component="dl" sx={{ maxWidth: 820, mx: 'auto', my: 0 }}>
        {rows.map((row, index) => (
          <Box
            key={row.title}
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '200px 1fr' },
              columnGap: 4,
              rowGap: 0.5,
              py: 2.75,
              px: 1,
              fontSize: 15,
              borderTop: (theme) => `1px solid ${theme.palette.line}`,
              ...(index === rows.length - 1 && {
                borderBottom: (theme) => `1px solid ${theme.palette.line}`,
              }),
            }}
          >
            <Box
              component="dt"
              sx={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 500, letterSpacing: '.1em', m: 0 }}
            >
              {row.title}
            </Box>
            <Box component="dd" sx={{ m: 0, color: 'text.secondary' }}>
              {row.detail.map((line, i) => (
                <React.Fragment key={line}>
                  {i > 0 ? <br /> : null}
                  {line}
                </React.Fragment>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Section>
  );
}

export default Company;
